document.addEventListener('DOMContentLoaded', ()=>{
    console.log('Hello!');
});

//# sourceMappingURL=simonolander.com.88c6a306.js.map
